import { Action } from '@ngrx/store';

export const featureKey = 'trackedRequests';

export declare type RequestStatus = 'in-progress' | 'success' | 'failure';
export interface TrackableAction extends Action {
  requestId?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any;
}

export interface State {
  requestIds: string[];
  requests: {
    [requestId: string]: {
      status: RequestStatus;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      error: any;
    };
  };
}

export const initialState: State = {
  requestIds: [],
  requests: {},
};

export function reducer(state = initialState, action: TrackableAction): State {
  if (action.requestId) {
    if (action.type.endsWith('_SUCCESS')) {
      return {
        requestIds: [...state.requestIds],
        requests: {
          ...state.requests,
          [action.requestId]: {
            status: 'success',
            error: null,
          },
        },
      };
    } else if (action.type.endsWith('_FAILURE')) {
      return {
        requestIds: [...state.requestIds],
        requests: {
          ...state.requests,
          [action.requestId]: {
            status: 'failure',
            error: action.error,
          },
        },
      };
    } else {
      if (state.requests[action.requestId]) {
        console.warn('TrackableAction: requestId already tracked.');
        return state;
      }

      return {
        requestIds: [...state.requestIds, action.requestId],
        requests: {
          ...state.requests,
          [action.requestId]: {
            status: 'in-progress',
            error: null,
          },
        },
      };
    }
  }

  return state;
}
